import { useRef } from "react";
import { useEventListener } from "usehooks-ts";
export const useMousePosition = () => {
    const positionRef = useRef({ x: 0, y: 0 });
    useEventListener("mousemove", (event) => {
        positionRef.current = { x: event.pageX, y: event.pageY };
    }, undefined, { passive: true, capture: true });
    return positionRef;
};
//# sourceMappingURL=useMousePosition.js.map